/// <amd-module name="VSSUI/Portal" />
export { Portal } from "./Components/Portal/Portal";
export { IPortalProps } from "./Components/Portal/Portal.Props";
